import React from "react";
import { currencies } from "../Utils/Lists";
import useCurrentCurrency from "../Utils/useCurrentCurrency";
import { useContent } from "contexts/contentContext/contentContext";

export interface PriceI {
  [key: string]: {
    [key: string]: number;
  };
}

interface PriceDisplayElemI {
  isYearly: boolean;
  prices: PriceI;
  tablePrice?: boolean;
  discount?: number;
}

const PriceDisplayElem = ({
  isYearly,
  prices,
  tablePrice,
  discount,
}: PriceDisplayElemI) => {
  const { getBlackFridayTime } = useContent();
  const currentUserCurrency = useCurrentCurrency();

  if (!prices) {
    return null;
  }

  const priceNoPromo = (price: number) => {
    const monthsQuantity = 12;
    const monthPrice = isYearly ? Math.ceil(price / monthsQuantity) : price;
    return monthPrice;
  };

  const priceIncludesPromo = (price: number) => {
    const monthPrice = priceNoPromo(price);
    if (getBlackFridayTime() && isYearly) {
      const discountCoefficient = discount ? 1 - discount / 100 : 0.7;
      return Math.ceil(monthPrice * discountCoefficient);
    }
  };

  const priceNumber =
    prices[isYearly ? "Price_Yearly" : "Price_Monthly"][currentUserCurrency];

  return (
    <div className="price-display">
      {isYearly && getBlackFridayTime() ? (
        <h3 className="current-price">
          <span className="currency-icon">
            {currencies[currentUserCurrency]}
          </span>
          {priceIncludesPromo(priceNumber)}
        </h3>
      ) : null}
      <h3
        className={`current-price ${
          isYearly && getBlackFridayTime() ? " strikediag" : ""
        }`}
      >
        {isYearly && getBlackFridayTime() && !tablePrice ? null : (
          <span className="currency-icon">
            {currencies[currentUserCurrency]}
          </span>
        )}
        {priceNoPromo(priceNumber)}
      </h3>
    </div>
  );
};

export default PriceDisplayElem;
